// ----------------------------------------------------------------------
// <copyright file="Izenda.SourceTree.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * SourceTree component
 */
!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');

  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');

  var Panel = require('share/components/controls/Izenda.Panel');
  var List = require('share/components/controls/Izenda.List');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var CollapsibleList = require('share/components/controls/Izenda.CollapsibleList');
  var SourceTreeItem = require('./Izenda.SourceTreeItem');
  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  const { isEmpty } = require('lodash/fp');

  function createTreeItem(tree, store, props) {
    return function(node) {
      return (
        <SourceTreeItem
          key={node.id}
          node={node}
          store={store}
          filter={tree.filter.text}
          showCheckbox={props.showCheckbox}
          showIcon={props.showIcon}
        />
      );
    };
  }

  /**
   * check rules of display nodes/fields of QuerySourceTree
   * @param  {Object}  querySourceNode
   * @param  {Boolean} showFieldNode
   * @return {Boolean} should display TreeNode (true) or TreeItem (false)
   */
  function checkDisplayingNode(querySourceNode, showFieldNode) {
    // only display TreeNode if childNodes have items or this node is TypeGroup
    if (!isEmpty(querySourceNode.childNodes) || querySourceNode.isTypeGroup()) {
      // only display TreeNode if this node is FieldNode & showFieldNode is ON
      return (querySourceNode.isFieldNode && showFieldNode) || !querySourceNode.isFieldNode ? true : false;
    }
    return false;
  }

  /**
   * display TreeNode/TreeItem of QuerySourceTree
   * @param  {Object}  tree
   * @param  {Object}  store
   * @param  {Object}  querySourceNode
   * @param  {Object} props
   * @return {Object} TreeNode/TreeItem
   */
  function treeNode(tree, store, querySourceNode, props) {
    var treeItem = createTreeItem(tree, store, props);

    return checkDisplayingNode(querySourceNode, props.showFieldNode) ? (
      <CollapsibleList
        className="panel-group collapsible-list-items datasource"
        key={querySourceNode.id}
        autoCollapse={false}
        defaultExpand={true}
      >
        <CollapsibleList.Item expanded={true} key={querySourceNode.id}>
          <CollapsibleList.ItemHeader className="panel-heading">{treeItem(querySourceNode)}</CollapsibleList.ItemHeader>

          <CollapsibleList.ItemBody className="panel-body">
            <List className="list-group" key={querySourceNode.id}>
              {querySourceNode.childNodes.map(function(child) {
                return props.showSelected && !child.checked
                  ? querySourceNode.isFieldNode
                    ? treeItem(child)
                    : null
                  : treeNode(tree, store, child, props);
              })}
            </List>
          </CollapsibleList.ItemBody>
        </CollapsibleList.Item>
      </CollapsibleList>
    ) : (
      treeItem(querySourceNode)
    );
  }

  var SourceTree = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      tree: React.PropTypes.object.isRequired,
      showSelected: React.PropTypes.bool,
      showCheckbox: React.PropTypes.bool,
      showFieldNode: React.PropTypes.bool,
      showIcon: React.PropTypes.bool
    },
    render: function() {
      var props = this.props;
      var store = props.store;
      var tree = props.tree;

      return (
        <Panel className="workspace-tree">
          <div className="workspace-tree-wraper">
            <ScrollBox>
              {tree.root.map(function(treeRootItem) {
                return treeRootItem.childNodes.map(function(node) {
                  return props.showSelected && !node.checked ? null : treeNode(tree, store, node, props);
                });
              })}
            </ScrollBox>
          </div>
        </Panel>
      );
    }
  });

  module.exports = connect()(SourceTree);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/RunCopy/Izenda.SourceTree.jsx